import Head from "next/head";

import ChangePasswordRequiredC from "@/components/auth/change-password-required";

export default function ChangePasswordRequired() {
  return (
    <>
      <Head>
        <title>Update Your Password — ShipVista</title>
      </Head>

      <ChangePasswordRequiredC />
    </>
  );
}
